export default __webpack_public_path__ + "static/media/pomodoro.4e69691a.png";